import { LazyQueryHookOptions, QueryHookOptions } from '@apollo/client';

import {
  useKioskAdSetQuery,
  useKioskAdSetLazyQuery,
  KioskAdSetQuery,
  KioskAdSetQueryVariables,
} from '@occc/graphql';
import { useLazyQuery } from '@occc-app/dataAccessLayer/utils';

type GetKioskAdSetProps = {
  id: string;
  baseOptions?: Omit<QueryHookOptions<KioskAdSetQuery, { id: string }>, 'variables'>;
};

export const useGetKioskAdSet = ({ id, baseOptions }: GetKioskAdSetProps) => {
  const response = useKioskAdSetQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    ...baseOptions,
    variables: { id },
  });

  return {
    ...response,
    adSet: response.data?.kioskAdSet,
  };
};

export const useGetKioskAdSetLazy = (
  baseOptions?: LazyQueryHookOptions<KioskAdSetQuery, KioskAdSetQueryVariables>,
) => {
  const [executeQuery, response] = useLazyQuery<KioskAdSetQuery, KioskAdSetQueryVariables>(
    useKioskAdSetLazyQuery,
    baseOptions,
  );

  return {
    executeQuery,
    response,
  };
};
